import React, { useState, useEffect } from "react";
import moment from "moment";
import customFetch from "./apicall/api";
import { ReloadOutlined } from "@ant-design/icons";
import DynamicForm from "./Report_dynamic_form"

const Form = ({ apiToken, reportListData }) => {
  const [reportConfig, setReportConfig] = useState(null);
  const [extraReportConfigFields, setExtraReportConfigFields] = useState(null);
  const [currentReportName, setCurrentReportName] = useState(null);
  const [currentReportId, setCurrentReportId] = useState(null);
  const [formState, setFormState] = useState({});
  const [isFetchingConfig, setIsFetchingConfig] = useState(false);
  const [isErrorWindowActive, setErrorWindowActive] = useState(false);
  const [errorWindowMessage, setErrorWindowMessage] = useState("");
  const [processedAtCount, setProcessedAtCount] = useState(0);
  const [isFetchingReportLog, setFetchingReportLog] = useState(false);
  const [reportData, setReportData] = useState([]);

  useEffect(() => {
    if (currentReportId) {
      setProcessedAtCount(0)
      setReportData([])
      getReportData()
    }
  }, [currentReportId])

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData();

    const uid = localStorage.getItem("in_userid");
    formData.append("userid", uid);
    formData.append("report_id", currentReportId);

    const fieldsToSubmit = [];
    let validFields = true;
    for (const key in formState) {
      if (formState.hasOwnProperty(key)) {
        const fieldState = formState[key];

        let is_req = true;
        if (reportConfig[key] && reportConfig[key].is_req !== null && reportConfig[key].is_req !== undefined) {
          is_req = reportConfig[key].is_req
          is_req = (is_req === "1" || is_req === true || is_req === "true" || is_req === 1);
        }

        // Check if value is present and not empty
        if (fieldState.isVisible && !fieldState.isFetching && fieldState.value && is_req) {
          // Handle special cases for calendar_daterange and calendar_yearmonthrange
          if (Array.isArray(fieldState.value)) {
            fieldState.value.forEach((item) => fieldsToSubmit.push({ id: item, value: item }))
          } else {
            const fieldData = {
              id: fieldState.id,
              value: fieldState.value,
            };

            fieldsToSubmit.push(fieldData);
          }
        }
        else if (fieldState.isVisible && (fieldState.isFetching || !fieldState.value)) {
          validFields = false;
          break;
        }
      }
    }
    formData.append("user_parameter", JSON.stringify(fieldsToSubmit))

    if (!validFields || (fieldsToSubmit.length === 0 && reportConfig && Object.keys(reportConfig).length > 0)) {
      setErrorWindowMessage(`Error sending request: Please try again.`);
      setErrorWindowActive(true);
      return;
    }

    if (validFields && (fieldsToSubmit.length === 0 || !reportConfig || Object.keys(reportConfig).length === 0)) {
      let nadata = [{}];
      nadata["nakey"] = "NA";
      formData.append("user_parameter", JSON.stringify(nadata, null));
    }

    setIsFetchingConfig(true)

    customFetch(`${process.env.REACT_APP_URL}/store/desktop/report/request/detail`, {
      method: 'POST',
      headers: {
        'api-token': apiToken,
      },
      body: formData,
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        if (
          data.api_code === 4 ||
          data.api_code === 3 ||
          data.api_code === 5
        ) {
          localStorage.clear();
          this.props.history.push("/");
        }
        getReportData()
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => setIsFetchingConfig(false))
  };

  // Helper to check if all visible fields are completed with textbox `status` check
  const areVisibleFieldsComplete = () => {
    return formState && Object.keys(formState).every((key) => {
      const field = formState[key];
      const config = reportConfig[key];
      if (!field || !field.isVisible) return true; // Skip non-visible fields
      if (config.type === "textbox") return field.value && config.status === 1; // Check textbox status
      return field.value !== "" && field.value !== null; // Check other field types
    });
  };

  // Helper to determine if any field is fetching data
  const isAnyFieldFetching = () => {
    return Object.keys(formState).some((key) => formState[key] && formState[key].isFetching);
  };

  const checkFetchingState = () => {
    return isFetchingConfig || isFetchingReportLog || isAnyFieldFetching();
  };

  const downloadReportUpdateDate = async (request_no, download_link = "") => {
    const reqId = request_no.split("/").at(-1)
    try {
      const response = await customFetch(
        process.env.REACT_APP_URL + "/fetch/report/datetime?request_id=" + reqId,
        {
          method: "GET",
          headers: {
            "api-token": apiToken,
          },
        }
      );
      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }
      window.location.href = download_link
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  const getHours = (create_at) => {
    const dateOneObj = new Date(create_at);
    const dateTwoObj = new Date();
    const milliseconds = Math.abs(dateTwoObj - dateOneObj);
    const hours = milliseconds / 36e5;
    return hours;
  }

  const getInputData = (inputdata) => {
    let x = inputdata;
    let result = "";

    // Case 1: When inputdata is an array
    if (Array.isArray(x)) {
      x.forEach((item) => {
        if (item.hasOwnProperty("value")) {
          let date = moment(item.value);
          if (date.isValid()) {
            let dateAdded = false;
            reportConfig && Object.keys(reportConfig).forEach((inputkey) => {
              const config = reportConfig[inputkey];
              if (
                config.type === "calendar_daterange" ||
                config.type === "calendar_date"
              ) {
                if (!dateAdded) {
                  result += moment(item.value).format("YYYY-MM-DD") + " | ";
                  dateAdded = true;
                }
              } else if (
                config.type === "calendar_yearmonth" ||
                config.type === "calendar_yearmonthrange"
              ) {
                if (!dateAdded) {
                  result += moment(item.value).format("MMM-YYYY") + " | ";
                  dateAdded = true;
                }
              }
            });
            if (!dateAdded) {
              result += item.value + " | ";
            }
          } else {
            result += item.value + " | ";
          }
        }
      });

      return result
        .trim()
        .replace(/\|([^|]*)$/, "$1")
        .trim();
    }
    // Case 2: When inputdata is an object
    else {
      const arr = Object.keys(x).map((key) => ({ [key]: x[key] }));
      return arr.map((arrdata) => {
        if (arrdata.month) {
          return arrdata.month;
        } else if (arrdata.lender_name) {
          return arrdata.lender_name;
        }
      });
    }
  };


  const getReportData = () => {
    setFetchingReportLog(true);
    const uid = localStorage.getItem("in_userid");
    const formdata = new FormData();
    formdata.append("userid", uid);
    formdata.append("report_id", currentReportId);
    customFetch(process.env.REACT_APP_URL + "/get/request/queue", {
      method: "POST",
      headers: { "api-token": apiToken },
      body: formdata,
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        const processed_AtCount = data.reduce((count, item) => {
          return item.completed_at === null ? count + 1 : count;
        }, 0);
        setProcessedAtCount(processed_AtCount)
        setReportData(data)
      })
      .catch((error) => {
        setErrorWindowActive(true);
        setErrorWindowMessage("Error fetching report history. Please try again.");
        setProcessedAtCount(99999) // Huge number to block send requests on error cases.
        console.error("Error fetching report history: " + error);
      })
      .finally(() => {
        setFetchingReportLog(false)
      })
  }

  return (
    <>
      {(checkFetchingState()) && (
        <div className="preloader">
          <div className="loader" ng-hide="data.length > 0"></div>
        </div>
      )}
      <div
        className={`modal fade ${isErrorWindowActive ? "show mymodal" : ""}`}
        tabIndex="-1"
        role="dialog"
        aria-labelledby="errorModalLabel"
        aria-hidden={!isErrorWindowActive}
        style={{ display: isErrorWindowActive ? "block" : "none" }}
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content cdb-confirm-box col-sm-12">
            <button
              type="button"
              className="close text-right"
              aria-label="Close"
              onClick={() => {
                setErrorWindowActive(false);
                setErrorWindowMessage(""); // Clear error message on close
              }}
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <p>{errorWindowMessage}</p>
          </div>
        </div>
      </div>
      <div className="mt-12">
        <div className="row">
          <DynamicForm
            apiToken={apiToken} reportListData={reportListData}
            reportConfig={reportConfig} setReportConfig={setReportConfig}
            extraReportConfigFields={extraReportConfigFields} setExtraReportConfigFields={setExtraReportConfigFields}
            currentReportId={currentReportId} setCurrentReportId={setCurrentReportId}
            currentReportName={currentReportName} setCurrentReportName={setCurrentReportName}
            formState={formState} setFormState={setFormState}
            isFetchingConfig={isFetchingConfig} setIsFetchingConfig={setIsFetchingConfig}
            isErrorWindowActive={isErrorWindowActive} setErrorWindowActive={setErrorWindowActive}
            errorWindowMessage={errorWindowMessage} setErrorWindowMessage={setErrorWindowMessage}
          />

          {currentReportId && (areVisibleFieldsComplete() && !checkFetchingState()) && (
            <div className="col-md-2">
              <span className="f18">&nbsp;</span>
              <button
                disabled={processedAtCount > 0}
                className={
                  processedAtCount > 0
                    ? "form-control btn-primary p-2 btn-height disablesendreqbtn"
                    : "form-control btn-primary p-2 btn-height"
                }
                onClick={handleSubmit}
              >
                Send Request
              </button>
            </div>
          )}
        </div>
        {currentReportId && (
          <div className="mt-4">
            <div className="float-right">
              <button
                className="btn btn-primary mb-1"
                onClick={() => getReportData()}
              >
                <ReloadOutlined />
              </button>
            </div>
            <div className="table-responsive">
              <table className="table text-center" style={{ tableLayout: "auto", width: "100%", verticalAlign: "middle" }}>
                <thead className="table-head">
                  <tr>
                    <th style={{ whiteSpace: "nowrap" }}>Request No.</th>
                    <th>Parameters Selected</th>
                    <th style={{ whiteSpace: "nowrap" }}>Submitted At</th>
                    <th style={{ whiteSpace: "nowrap" }}>Completed At</th>
                    <th style={{ whiteSpace: "nowrap" }}>Download Link</th>
                  </tr>
                </thead>
                {reportData.length > 0 ? (
                  <tbody>
                    {reportData.map((report) => (
                      <tr key={report.Request_No}>
                        <td style={{ whiteSpace: "nowrap" }}>{report.Request_No}</td>
                        <td style={{ whiteSpace: "normal", wordBreak: "break-word" }}>{getInputData(report.Parameter_Selected)}</td>
                        <td style={{ whiteSpace: "nowrap" }}>
                          {moment(report.Submitted_At).format("DD-MMM-YY HH:mm")}
                        </td>
                        <td style={{ whiteSpace: "nowrap" }}>
                          {report.completed_at &&
                            moment(report.completed_at).format("DD-MMM-YY HH:mm")}
                        </td>
                        <td style={{ whiteSpace: "nowrap" }}>
                          {report.Download_Link ? (
                            getHours(report.completed_at) <= 24 ? (
                              <a
                                // href={report.Download_Link}
                                onClick={() => downloadReportUpdateDate(report.Request_No, report.Download_Link)}
                                className="download-link"
                              >
                                Download
                              </a>
                            ) : (
                              "Link Expired"
                            )
                          ) : report.processed_flag == 3 ? (
                            "Invalid Link"
                          ) : (
                            "Processing Request"
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                ) : (
                  <tr>
                    <td colSpan="5">
                      <div className="text-center py-3">No Report History found</div>
                    </td>
                  </tr>
                )}
              </table>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Form;
